import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { enabledFunctionGroups, getLabel, getSortedFunctionGroups, initialFunctionGroupFilter } from "./FilterTypes/FunctionGroupFilterType";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const FunctionGroupFilter = () => {
  const title = RESX.Company.Profile;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("functionGroups", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedFunctionGroups(filter).map(fg => getLabel(fg)).join(", ")}</>,
    hasValue: (filter) => filter.selectedFunctionGroups.length > 0,
    reset: () => initialFunctionGroupFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedFunctionGroups.map(s => s), b.selectedFunctionGroups.map(s => s))
  });
  useEffect(() => {
    setInitialValue("functionGroups", initialFunctionGroupFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedFunctionGroups, setSelectedFunctionGroups] = React.useState(initialFunctionGroupFilter.selectedFunctionGroups);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedFunctionGroups(getValue("functionGroups").selectedFunctionGroups);
    setPopupOpen(true);
  };

  const onFunctionGroupToggle = (functionGroup: server.dto.FunctionGroups) => {
    const isSelected = selectedFunctionGroups.some(v => v === functionGroup);
    const newSelection = isSelected
      ? selectedFunctionGroups.filter(v => v !== functionGroup)
      : [...selectedFunctionGroups, functionGroup];
    setSelectedFunctionGroups(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("functionGroups", {
      selectedFunctionGroups
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={enabledFunctionGroups}
            selectedItems={selectedFunctionGroups}
            onItemToggled={onFunctionGroupToggle}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default FunctionGroupFilter;